if(!customElements.get('collections-slider')) {
  class ComponentSliderIconText extends HTMLElement {
    constructor() {
      super();
      this.sliderElement = this.querySelector('.keen-slider');
      this.sliderObj = null;
      this.carouselMode = this.dataset.carouselMode;
      this.carouselLoop = this.dataset.carouselLoop;
      this.carouselAutoplay = this.dataset.carouselAutoplay;
      this.carouselIndicator = this.querySelector('.slide-marker span');

      setTimeout(()=>{ //The timeout is for the customizer
        this.initSlider();
      }, 1);
    }

    initSlider() {
      var config = {
        mode: 'free-snap',
        loop: false,
        prevButton: this.querySelector('.keen-arrow.prev') ? this.querySelector('.keen-arrow.prev') : false,
        nextButton: this.querySelector('.keen-arrow.next') ? this.querySelector('.keen-arrow.prev') : false,
        autoplay: false,
        spacing: 20,
        navBar: this.querySelector('.keen-nav-bar') ? this.querySelector('.keen-nav-bar') : false, 
        rubberband: false,
        breakpoints: {         
          '(min-width: 601px) and (max-width: 900px)': {
            slidesPerView: 2.15,
            spacing: 16
          },
          '(max-width: 600px)': {
            slidesPerView: 1.2,
            spacing: 10
          }
      }
    }
    this.sliderObj = new KeenSlider(this.sliderElement, config);
  }
  }
  customElements.define('collections-slider', ComponentSliderIconText);
}